import { ajax } from './api';

export interface LayerTemplateWebReferenceDto {
  repositoryName: string;
  id: string;
  printName: string;
  active: boolean;
}

/**
 * Returns all matching layer templates from all repositories
 * that are usable for the given selected layer
 *
 * @param layerId - Selected layer id
 * @param mapScale - Current map scale
 * @return Promise
 */
export function getLayerTemplates (layerId: string, mapScale: string): Promise<LayerTemplateWebReferenceDto[]> {
  // @ts-ignore
  return ajax('/layerTemplates', {
    method: 'GET',
    data: {
      applicableTo: layerId,
      mapScale
    }
  });
}

/**
 * Applies the selected template to the selected layer
 *
 * @param layerId - Layer on which the template is to be applied
 * @param template - Template to apply
 * @return Promise
 */
export function applyTemplate (layerId: string, template: LayerTemplateWebReferenceDto) {
  return ajax(`/layers/${layerId}/template`, {
    method: 'PUT',
    contentType: 'application/json',
    data: JSON.stringify(template)
  });
}
